import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight, Globe } from "lucide-react";
import { company } from "../lib/data";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="relative inline-flex items-center gap-1">
              <span className="relative inline-flex h-10 w-10 items-center justify-center">
                <span className="absolute inset-0 bg-[#dc2626] -skew-x-12" />
                <span className="relative font-display font-black text-white text-xl">
                  D
                </span>
              </span>
              <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#1d4ed8] text-white">
                <Globe className="h-5 w-5" strokeWidth={2} />
              </span>
            </span>
            <div className="leading-tight">
              <div className="font-display font-bold text-white text-xl">
                {company.name}
              </div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 mt-0.5">
                Unified Financial Partner
              </div>
            </div>
          </div>
          <p className="text-neutral-400 max-w-md leading-relaxed">
            A full-stack fintech company connecting individuals, SMEs and
            corporates to the right credit, protection and financial solutions
            through a trusted network of leading banks, NBFCs and financial
            institutions.
          </p>
          <Link
            to="/request-access"
            data-testid="footer-cta-request-access"
            className="mt-6 inline-flex items-center gap-2 bg-[#1d4ed8] hover:bg-[#2563eb] text-white px-5 py-3 text-sm font-semibold"
          >
            Talk to an Expert <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-neutral-500 mb-4">
            Explore
          </div>
          <ul className="space-y-3 text-neutral-300">
            <li>
              <Link to="/" className="hover:text-white transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-white transition-colors">
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-white transition-colors"
              >
                Services
              </Link>
            </li>
            <li>
              <Link to="/tools" className="hover:text-white transition-colors">
                EMI &amp; Eligibility
              </Link>
            </li>
            <li>
              <Link to="/faq" className="hover:text-white transition-colors">
                FAQ
              </Link>
            </li>
            <li>
              <Link
                to="/request-access"
                className="hover:text-white transition-colors"
              >
                Request Access
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-white transition-colors"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-neutral-500 mb-4">
            Reach Us
          </div>
          <ul className="space-y-4 text-neutral-300 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-1 text-[#dc2626] flex-shrink-0" />
              <span data-testid="footer-address">{company.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[#dc2626]" />
              <div className="flex flex-col">
                <a
                  href={company.phoneHref}
                  data-testid="footer-phone"
                  className="font-mono hover:text-white"
                >
                  {company.phone}
                </a>
                <a
                  href={company.phoneAltHref}
                  data-testid="footer-phone-alt"
                  className="font-mono hover:text-white text-xs text-neutral-400"
                >
                  {company.phoneAlt}
                </a>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-[#dc2626]" />
              <a
                href={`mailto:${company.email}`}
                className="hover:text-white"
                data-testid="footer-email"
              >
                {company.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <div>
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </div>
          <div className="font-mono uppercase tracking-[0.25em]">
            End-to-end compliant · Audit-ready
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
